document.addEventListener("DOMContentLoaded", function () {
  // PMPro's own inline script (paid-memberships-pro/includes/login.php) is
  // supposed to move this wrapper inside .login-password before this handler
  // runs, but that depends on the inline <script> executing immediately and
  // untouched (e.g. NitroPack's JS delay/optimization can defer or drop it).
  // If it never ran, the toggle is left as a sibling after the whole form —
  // rendering unstyled at the bottom of the card — so re-parent it ourselves.
  document
    .querySelectorAll(".pmpro_form_field-password-toggle")
    .forEach((toggleWrapper) => {
      // PMPro can wrap the whole login card in .pmpro_form_field. Only the
      // password field itself is a valid final location for this control.
      if (toggleWrapper.closest(".login-password")) {
        return; // already positioned correctly
      }

      // PMPro emits this after the login form (and after the forgot/register
      // links), so it is not necessarily a child or adjacent sibling of the
      // form. Target the form's password field directly.
      const passwordField = document.querySelector(
        "#loginform .login-password"
      );

      if (passwordField) {
        passwordField.appendChild(toggleWrapper);
      }
    });

  // Select the input fields
  const usernameField = document.querySelector(".login-username");
  const passwordField = document.querySelector(".login-password");

  const usernameInput = document.querySelector(".login-username #user_login");
  const passwordInput = document.querySelector("#user_pass");

  const floatingForms = document.querySelectorAll(".form-floating");

  const toggles = document.querySelectorAll(
    ".pmpro_form_field-password-toggle button"
  );

  const eyeOn = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--pmpro--color--accent)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>`;

  const eyeOff = `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--pmpro--color--accent)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off">
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
          <line x1="1" y1="1" x2="23" y2="23"></line>
        </svg>`;

  function updateToggleAppearance(btn, input) {
    const stateText = btn.querySelector(
      ".pmpro_form_field-password-toggle-state"
    );
    const iconWrapper = btn.querySelector("span.pmpro_icon");

    if (input.type === "password") {
      stateText.textContent = "Show Password";
      iconWrapper.innerHTML = eyeOff;
    } else {
      stateText.textContent = "Hide Password";
      iconWrapper.innerHTML = eyeOn;
    }
  }

  toggles.forEach((btn) => {
    const input = btn
      .closest(".login-password, .pmpro_form_field, .form-group-password")
      .querySelector("input");
    if (!input) { return; }

    updateToggleAppearance(btn, input);

    btn.addEventListener(
      "click",
      (e) => {
        e.preventDefault(); 
        e.stopImmediatePropagation(); // cancels PMPro JS

        // Our toggle
        if (input.type === "password") {
          input.type = "text";
        } else {
          input.type = "password";
        }
        updateToggleAppearance(btn, input);
      },
      true // capture phase — runs before PMPro listener
    );
  });

  // Function to check and update label position
  function updateLabel(field, input) {
    if (!field || !input) { return; }

    if (input.value.length > 0) {
      field.classList.add("focused");
    } else {
      field.classList.remove("focused");
    }
  }

  // -------------------------------
  // Attach listeners to each field
  // -------------------------------
  function attachFloatingLabel(field, input) {
    if (!field || !input) { return; }

    input.blur();

    // Attach listeners BEFORE anything else
    input.addEventListener("focus", () => {
      field.classList.add("focused");
    });

    input.addEventListener("blur", () => {
      updateLabel(field, input);
    });

    input.addEventListener("input", () => {
      updateLabel(field, input);
    });

    input.addEventListener("change", () => {
      updateLabel(field, input);
    });

    // Initial call in case autofill already filled it
    updateLabel(field, input);
  }

  function applyFloatingLabels(form) {
    if (!form) { return; }

    const inputs = form.querySelectorAll(
      "input[type='text'], input[type='password'], input[type='email'], textarea, select"
    );

    inputs.forEach((input) => {
      const group = input.closest(".form-group");
      if (group) { attachFloatingLabel(group, input); }
    });
  }

  attachFloatingLabel(passwordField, passwordInput);
  attachFloatingLabel(usernameField, usernameInput);

  floatingForms.forEach((form) => {
    applyFloatingLabels(form);
  });
});
